const QRScanner= () => {
    return null
}

export default QRScanner;